import { Box, Button, Typography } from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cleanDatabase } from 'store/actions';
import { selectMetadata, selectToken } from 'store/selectors';

import { buttonStyle } from './DatabaseCleanup.style';

const DatabaseCleanup = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const md = useSelector(selectMetadata);

  const cleanupDatabase = () => {
    dispatch(cleanDatabase(token));
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h5">Clean Hanging Database Entries</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Last cleanup: {md.last_database_cleanup ?? 'N/A'}
      </Typography>

      <Button variant="contained" onClick={cleanupDatabase} sx={buttonStyle}>
        Clean
      </Button>
    </Box>
  );
};

export default DatabaseCleanup;
